<template >
  <Modal v-bind="$attrs" @cancel="$emit('cancel')" @confirm="onFormValidate">
    <el-form v-if="$attrs.visible" ref="form" @submit.native.prevent :model="budgetForm" :rules="rules" label-width="80px">
      <el-form-item label="目标出价" prop="bid_amount">
        <InputRange v-model="budgetForm.bid_num_range" v-if="rawBidForm.bid_range"></InputRange>
        <el-input v-model="budgetForm.bid_amount" v-else placeholder="请输入出价"></el-input>
      </el-form-item>

      <template v-if="rawBidForm.deep_bid_mode">
        <el-form-item
          label="深度出价"
          :prop="rawBidForm.deep_conversion_spec.deep_conversion_type === DEEP_CONVERSION_TYPE.BEHAVIOR ? 'deep_bid_amount' : 'deep_roi'"
        >
          <template v-if="rawBidForm.deep_conversion_spec.deep_conversion_type === DEEP_CONVERSION_TYPE.BEHAVIOR">
            <InputRange
              v-model="budgetForm.deep_conversion_spec.deep_conversion_behavior_spec.deep_deepbid_num_range"
              v-if="rawBidForm.deep_conversion_spec.deep_conversion_behavior_spec.deep_bid_range"
            ></InputRange>
            <el-input
              v-model="budgetForm.deep_conversion_spec.deep_conversion_behavior_spec.bid_amount"
              v-else
              placeholder="请输入出价"
            ></el-input>
          </template>

          <el-input
            v-else
            v-model="budgetForm.deep_conversion_spec.deep_conversion_worth_spec.expected_roi"
            placeholder="请输入roi出价"
          ></el-input>
        </el-form-item>
      </template>
    </el-form>
  </Modal>
</template>
<script>
import getBidFormRules from '@/views/create/gdt/model/budget/budget-rules.js'
import { DEEP_CONVERSION_TYPE } from '@/views/create/gdt/model/budget/budget-const.js'
import Modal from './modal.vue'
import InputRange from '@/views/edit/kuaishou/components/input-range'

export default {
  components: { Modal, InputRange },
  inject: ['previewTable'],
  data() {
    return {
      DEEP_CONVERSION_TYPE,
      rules: getBidFormRules.call(this),
      budgetForm: {}
    }
  },
  computed: {
    rawBidForm() {
      return this.previewTable.currentModifyTableRow?.bid || {}
    }
  },

  watch: {
    '$attrs.visible'(v) {
      if (v) {
        this.budgetForm = this.rawBidForm
      }
    }
  },
  methods: {
    onConfirm() {
      const { bid_range, deep_bid_mode } = this.rawBidForm
      const { bid_num_range, bid_amount, deep_conversion_spec: deepSpec } = this.budgetForm

      const newBidValues = {}

      if (bid_range) {
        newBidValues.bid_num_range = bid_num_range
      } else {
        newBidValues.bid_amount = bid_amount
      }

      if (deep_bid_mode) {
        newBidValues.deep_conversion_spec = deepSpec
      }

      this.$emit('confirm', newBidValues)
    },
    onFormValidate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.onConfirm()
        }
      })
    }
  }
}
</script>
